/*
  Holds the page still behind the open cart drawer on phones. Dawn only sets
  overflow hidden on the body, and iPhone Safari still lets the page (and the
  full-screen drawer with it) move under a swipe. Pinning the body at its
  scroll position is the hold Safari respects; the page goes back to the
  same place when the drawer closes (Mustafa, 19 Oct).

  Watches the drawer's "active" class, so Dawn's cart-drawer.js is unchanged.
  Loaded by snippets/nr-cart-drawer.liquid.
*/
(() => {
  const drawer = document.querySelector('cart-drawer.nr-cart-drawer');
  if (!drawer || drawer.dataset.nrLock) return;
  drawer.dataset.nrLock = 'on';

  const phone = window.matchMedia('(max-width: 749px)');
  const body = document.body;
  let locked = false;
  let top = 0;

  const lock = () => {
    if (locked || !phone.matches) return;
    top = window.scrollY;
    body.style.position = 'fixed';
    body.style.top = `-${top}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    locked = true;
  };

  const unlock = () => {
    if (!locked) return;
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    window.scrollTo(0, top);
    locked = false;
  };

  new MutationObserver(() => {
    if (drawer.classList.contains('active')) lock();
    else unlock();
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
})();
